
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#525F7F"}},[_c('path',{attrs:{"d":"M10.363 5H5.725a.58.58 0 00-.58.58v4.638c0 .32.26.58.58.58h4.638c.32 0 .58-.26.58-.58V5.58a.58.58 0 00-.58-.58zM17.319 5h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.638c.32 0 .58-.26.58-.58V5.58a.58.58 0 00-.58-.58zM10.362 11.957H5.725a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.637c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58zM17.319 11.957h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.638c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58zM24.276 5h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.637c.32 0 .58-.26.58-.58V5.58a.58.58 0 00-.58-.58zM24.276 11.957h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.637c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58zM10.362 19.203H5.725a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.637c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58zM17.319 19.203h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.638c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58zM24.276 19.203h-4.638a.58.58 0 00-.58.58v4.637c0 .32.26.58.58.58h4.637c.32 0 .58-.26.58-.58v-4.638a.58.58 0 00-.58-.58z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    